import { createContext, useCallback, useContext, useEffect, useRef, useState, type ReactNode } from 'react';

/** Avisos breves («toast») que aparecen abajo y desaparecen solos. */
const Contexto = createContext<(mensaje: string) => void>(() => {});

export function AvisosProvider({ children }: { children: ReactNode }) {
  const [mensaje, setMensaje] = useState('');
  const temporizador = useRef<number | undefined>(undefined);

  const mostrar = useCallback((m: string) => {
    setMensaje(m);
    window.clearTimeout(temporizador.current);
    temporizador.current = window.setTimeout(() => setMensaje(''), 3400);
  }, []);

  useEffect(() => () => window.clearTimeout(temporizador.current), []);

  return (
    <Contexto.Provider value={mostrar}>
      {children}
      {mensaje ? <div className="toast" role="status">{mensaje}</div> : null}
    </Contexto.Provider>
  );
}

export function useAviso() {
  return useContext(Contexto);
}

/** Ejecuta una función tras una espera (para las respuestas simuladas), cancelándola al salir. */
export function useRetardo() {
  const ref = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(ref.current), []);
  return useCallback((fn: () => void, ms: number) => {
    window.clearTimeout(ref.current);
    ref.current = window.setTimeout(fn, ms);
  }, []);
}
